import React from 'react';
import SIcon from './SIcon';
import { faPen } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faPen} fa />;

export default Icon;
